var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.linkType,_vm._b({tag:"component",staticClass:"link",class:{
  'link--primary': _vm.variant === 'primary',
  'link--secondary': _vm.variant === 'secondary',
  'link--tertiary': _vm.variant === 'tertiary',
  'link--quiet': _vm.isQuiet,
  'link--external': _vm.external
},attrs:{"target":_vm.computedTarget,"rel":_vm.computedRel}},"component",_vm._d({},[_vm.linkProp,_vm.url])),[_c('span',{staticClass:"link__text"},[_vm._v(_vm._s(_vm.text))]),(_vm.icon)?_c('sword-icon-wuk',{attrs:{"name":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }